import { useMemo } from 'react';
import type { RoleBoard } from '../../types/taActionBoard';
import { useInterviewAvailability } from '../../components/interviewAvailability/useInterviewAvailability';
import { useOptionalGmailConnection } from './GmailConnectionContext';

/**
 * The interview availability light for every role on this board — the same
 * numbers the Pipeline Radar shows, from the board's own (unredacted) door.
 *
 * Passes the board's Google token when one is connected, which is what lets
 * the proxy read a role's kick-off sheet for a panel nobody has configured yet.
 * What it finds is remembered server-side, so the Radar's light fills in too.
 */
export function useBoardAvailability(roles: RoleBoard[]) {
  const gmail = useOptionalGmailConnection();
  const list = useMemo(() => roles.map((r) => ({ postingId: r.postingId, title: r.roleTitle })), [roles]);
  return useInterviewAvailability('board', list, gmail?.token ?? null);
}
